import { User } from "oidc-client";

export const serializeOidcUser = (user: User) => {
  const serilizableUser = {
    id_token: user.id_token || "",
    session_state: user.session_state || "",
    access_token: user.access_token || "",
    token_type: user.token_type || "",
    scope: user.scope || "",
    profile: {
      s_hash: user.profile?.s_hash || "",
      sid: user.profile?.sid || "",
      sub: user.profile?.sub || "",
      auth_time: user.profile?.auth_time || 0,
      idp: user.profile?.idp || "",
      amr: user.profile?.amr || [],
      emailaddress:
        user.profile?.[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
        ] || "",
      name:
        user.profile?.[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
        ] || "",
      picture: user.profile?.picture || "",
      role:
        user.profile?.[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ] || "",
    },
    expires_at: user.expires_at || 0,
  };
  return serilizableUser;
};
